const TYPE_STYLES = {
  trend: "border-blue-800/60 bg-blue-950/30",
  pattern: "border-purple-800/60 bg-purple-950/30",
  correlation: "border-cyan-800/60 bg-cyan-950/30",
  warning: "border-amber-800/60 bg-amber-950/30",
  default: "border-gray-800 bg-gray-900/60",
};

export default function InsightCard({ type, title, message, icon }) {

  const style = TYPE_STYLES[type] || TYPE_STYLES.default;

  return (
    <div className={`p-4 rounded-xl border ${style} hover:brightness-125 transition-all`}>

      <div className="flex items-center gap-2 mb-1.5">
        <span className="text-lg shrink-0">{icon}</span>
        <h3 className="font-semibold text-white text-sm leading-snug">{title}</h3>
      </div>

      <p className="text-gray-400 text-xs leading-relaxed">{message}</p>
    </div>
  );
}
